'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectRecipientReportDetailed = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectRecipientReportDetailed, _Component);

  function ProjectRecipientReportDetailed() {
    (0, _classCallCheck3.default)(this, ProjectRecipientReportDetailed);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientReportDetailed.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientReportDetailed)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectRecipientReportDetailed, [{
    key: 'render',


    /* eslint-disable react/no-array-index-key */
    value: function render() {
      var _props = this.props,
          t = _props.t,
          reportData = _props.reportData;
      var _reportData$timings = reportData.timings,
          timings = _reportData$timings === undefined ? [] : _reportData$timings,
          _reportData$files = reportData.files,
          files = _reportData$files === undefined ? {} : _reportData$files;


      if (!timings.length) {
        return _react2.default.createElement(_components.NoRecords, null);
      }

      return _react2.default.createElement(
        _components.List,
        null,
        _react2.default.createElement(
          _components.ListItem,
          { fullWidth: true, isTitle: true },
          _react2.default.createElement(
            'div',
            null,
            t('Track')
          ),
          _react2.default.createElement(
            'div',
            null,
            t('Duration')
          ),
          _react2.default.createElement(
            'div',
            null,
            t('Time')
          )
        ),
        timings.map(function (timing, index) {
          return _react2.default.createElement(
            _components.ListItem,
            { key: timing.uploadId + '_' + index, fullWidth: true },
            _react2.default.createElement(
              'div',
              null,
              files[timing.uploadId].filename
            ),
            _react2.default.createElement(
              'div',
              null,
              t('Play'),
              ' ',
              timing.durationString
            ),
            _react2.default.createElement(
              'div',
              null,
              timing.dateString
            )
          );
        })
      );
    }
    /* eslint-enable react/no-array-index-key */

  }]);
  return ProjectRecipientReportDetailed;
}(_react.Component), _class2.propTypes = {
  reportData: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = ProjectRecipientReportDetailed;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectRecipientReportDetailed.js
// module id = 2052
// module chunks = 1